<template>
  <v-container 
    :class="scrollArrowClass"
    :style="scrollArrowStyle"
    v-if="show"
    >
    <v-btn 
      id="scroll-up-down"
      class="arrow-button ma-5"
      active-class="no-active"
      fab 
      :ripple="false" 
      depressed 
      :color="buttonColor" 
      @click="onClick">
      <v-icon>
        {{ icon }}
      </v-icon>
    </v-btn>
  </v-container>
</template>

<script>
  import icons from '@/mixins/icons'
  import ui from '@/mixins/ui'

  export default {
    name: 'scrollarrow',
    mixins: [ icons, ui ],
    props: {
      show: Boolean,
      arrowAlignment: {
        type: String,
        default: "bottom"
      },
      position: {
        type: String,
        default: "absolute"
      },
      color: String
    },
    computed: {
      scrollArrowClass() {
        let overlayClasses = 'justify-center d-flex flex-wrap '

        if (this.arrowAlignment === "bottom") {
          return overlayClasses + 'align-end'
        } else {
          return overlayClasses + 'align-start'
        }
      },
      scrollArrowStyle() {
        return {
          position: this.position,
          zIndex: "4",
          pointerEvents: "none"
        }
      },
      icon() {
        if (this.arrowAlignment === "bottom") {
          return this.icons.mdiArrowDown
        } else {
          return this.icons.mdiArrowUp
        }
      },
      buttonColor() {
        if (this.color) {
          return this.color
        } else if (this.cardClass() === 'intro-dark') {
          return 'var(--white-10)'
        } else {
          return 'var(--primary-blue-10)'
        }
      }
    },
    methods: {
      onClick() {
        if (this.arrowAlignment === "bottom") {
          this.$emit('scrollDown')
        } else {
          this.$emit('scrollUp')
        }
      }
    }
  }
</script>

<style>
  .arrow-button {
    pointer-events: auto;
  }
  .arrow-button.v-btn:focus::before, .arrow-button.v-btn::before {
    opacity: 0.08;
  }
</style>
